export interface ComicChapter {
  id: string;
  title: string;
  chapterNumber: number;
  updateTime: string;
  pageCount: number;
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  coverImage: string;
  description: string;
  longDescription: string;
  status: '连载中' | '已完结';
  categories: string[];
  rating: number;
  viewCount: number;
  favoriteCount: number;
  updateTime: string;
  chapters: ComicChapter[];
  tags: string[];
}

export const categories = [
  { slug: 'all', name: '全部' },
  { slug: 'guoman', name: '国产漫画' },
  { slug: 'rexue', name: '热血' },
  { slug: 'lianai', name: '恋爱' },
  { slug: 'xuanhuan', name: '玄幻' },
  { slug: 'wuxia', name: '武侠' },
  { slug: 'kehuan', name: '科幻' },
  { slug: 'xuanyi', name: '悬疑' },
  { slug: 'gaoxiao', name: '搞笑' },
  { slug: 'qihuan', name: '奇幻' },
  { slug: 'dushi', name: '都市' },
];

export const comics: Comic[] = [
  {
    id: 'heilianhua',
    title: '黑莲花攻略手册',
    author: '白羽摘雕弓',
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20ink%20painting%20style%20manga%20cover%20featuring%20a%20beautiful%20woman%20in%20traditional%20hanfu%20dress%20with%20dark%20lotus%20flowers%20surrounding%20her%2C%20mysterious%20atmosphere%2C%20soft%20candlelight%2C%20ancient%20Chinese%20palace%20background%2C%20delicate%20brushwork%2C%20warm%20amber%20and%20deep%20crimson%20color%20palette%2C%20vertical%20composition%20for%20book%20cover%2C%20clean%20minimal%20background&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    description: '穿进狗血玄幻小说《捉妖》后，凌妙妙为完成任务，被迫攻略那个身世悲惨的腹黑少年慕声。他阴郁、暴戾、不择手段，却唯独对她露出最柔软的一面。',
    longDescription: '大学生凌妙妙穿进了自己刚看完的狗血玄幻小说《捉妖》中，成为了书中一个注定惨死的炮灰女配。为了回到现实世界，她必须完成系统布置的任务——攻略那个在原著中疯狂又偏执的腹黑少年慕声。慕声自幼被家族遗弃，在暗无天日的地牢中长大，养成了阴郁暴戾、不择手段的性格。然而在凌妙妙的温暖与坚持下，这个看似冷酷无情的少年，逐渐对她卸下心防，露出了不为人知的柔软一面。一场关于救赎与成长的奇幻之旅，就此展开……',
    status: '连载中',
    categories: ['guoman', 'lianai', 'xuanhuan'],
    rating: 9.6,
    viewCount: 12850000,
    favoriteCount: 3560000,
    updateTime: '2026-08-04',
    tags: ['穿越', '系统', '攻略', '古风', '甜宠', '成长'],
    chapters: Array.from({ length: 156 }, (_, i) => ({
      id: `hlh-ch-${i + 1}`,
      title: i === 0 ? '第1话 穿书' : `第${i + 1}话`,
      chapterNumber: i + 1,
      updateTime: new Date(2026, 7, 4 - Math.floor(i / 3)).toISOString().split('T')[0],
      pageCount: 18 + Math.floor(Math.random() * 12),
    })),
  },
  {
    id: 'xingchenbian',
    title: '星辰变',
    author: '我吃西红柿',
    coverImage: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20xianxia%20manga%20cover%20with%20a%20young%20warrior%20floating%20among%20stars%20and%20galaxies%2C%20cosmic%20energy%20surrounding%20him%2C%20dramatic%20celestial%20landscape%20with%20nebula%20clouds%2C%20ancient%20Chinese%20cultivation%20aesthetic%2C%20golden%20and%20deep%20blue%20cosmic%20tones%2C%20clean%20simple%20background%2C%20vertical%20book%20cover%20style&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    description: '秦羽天生无法修炼内功，为了得到父亲的重视，他毅然选择修炼痛苦艰难的外功。一场流星雨改变了他的命运，开启了一段逆天成长的传奇之路。',
    longDescription: '秦羽是镇东王秦德的三儿子，天生丹田有缺，无法修炼内功。为了得到父亲的重用和认可，他毅然选择了最为痛苦艰难的外功修炼之路。就在所有人都认为他注定平庸时，一颗从天而降的流星泪彻底改变了他的命运。从此，星空之下，多了一位逆天而行的传奇强者。',
    status: '连载中',
    categories: ['xuanhuan', 'rexue'],
    rating: 9.5,
    viewCount: 15680000,
    favoriteCount: 4200000,
    updateTime: '2026-08-03',
    tags: ['玄幻', '修仙', '热血', '成长', '星空'],
    chapters: Array.from({ length: 203 }, (_, i) => ({
      id: `xcb-ch-${i + 1}`,
      title: `第${i + 1}话`,
      chapterNumber: i + 1,
      updateTime: new Date(2026, 7, 3 - Math.floor(i / 3)).toISOString().split('T')[0],
      pageCount: 16 + Math.floor(Math.random() * 14),
    })),
  },
  {
    id: 'doupocangqiong',
    title: '斗破苍穹',
    author: '天蚕土豆',
    coverImage: 'https://readdy.ai/api/search-image?query=Dynamic%20Chinese%20fantasy%20manga%20cover%20with%20a%20determined%20young%20man%20wielding%20a%20massive%20flame%20sword%2C%20fiery%20battle%20aura%20surrounding%20him%2C%20ancient%20Chinese%20cultivation%20world%20backdrop%2C%20dramatic%20lighting%20with%20orange%20and%20red%20fire%20effects%2C%20action%20pose%2C%20clean%20minimal%20background%2C%20vertical%20book%20cover%20style&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    description: '天才少年萧炎在创造了家族空前绝后的修炼纪录后，突然变成了废人。在绝望之际，一缕灵魂从他手上的戒指里浮现，一扇全新的大门就此开启。',
    longDescription: '萧炎，昔日天才少年，却在一夜之间失去所有。功力倒退、受尽冷眼嘲讽、未婚妻上门退婚……种种打击接踵而至。就在他陷入绝望的深渊时，一缕灵魂从他手上的戒指里浮现而出——药老的出现，为他打开了一扇全新的大门。三十年河东，三十年河西，莫欺少年穷！',
    status: '已完结',
    categories: ['xuanhuan', 'rexue'],
    rating: 9.7,
    viewCount: 23500000,
    favoriteCount: 6800000,
    updateTime: '2026-06-15',
    tags: ['玄幻', '热血', '成长', '炼药', '经典'],
    chapters: Array.from({ length: 420 }, (_, i) => ({
      id: `dpcq-ch-${i + 1}`,
      title: `第${i + 1}话`,
      chapterNumber: i + 1,
      updateTime: new Date(2026, 5, 15 - Math.floor(i / 5)).toISOString().split('T')[0],
      pageCount: 15 + Math.floor(Math.random() * 15),
    })),
  },
  {
    id: 'quanzhigaoshou',
    title: '全职高手',
    author: '蝴蝶蓝',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20esports%20themed%20Chinese%20manga%20cover%20featuring%20a%20cool%20male%20gamer%20holding%20a%20glowing%20mouse%2C%20digital%20game%20interface%20elements%20in%20background%2C%20cyberpunk%20aesthetic%20mixed%20with%20Chinese%20art%20style%2C%20neon%20accents%2C%20confident%20expression%2C%20clean%20simple%20background%2C%20vertical%20book%20cover%20style&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    description: '网游荣耀中被誉为教科书级别的顶尖高手叶修，因为种种原因遭到俱乐部驱逐。他栖身于一家网吧，重新开始了他重返巅峰之路。',
    longDescription: '在网游《荣耀》中，叶修被誉为教科书级别的顶尖高手。然而因为种种原因，他遭到俱乐部的驱逐，被迫离开职业圈。他栖身于一家小小的网吧之中，一切从零开始。凭着手中那把自制的银武千机伞，他重新踏上了重返巅峰的征途。',
    status: '已完结',
    categories: ['guoman', 'rexue'],
    rating: 9.8,
    viewCount: 18900000,
    favoriteCount: 5200000,
    updateTime: '2026-05-20',
    tags: ['电竞', '热血', '竞技', '网游', '经典'],
    chapters: Array.from({ length: 180 }, (_, i) => ({
      id: `qzgs-ch-${i + 1}`,
      title: `第${i + 1}话`,
      chapterNumber: i + 1,
      updateTime: new Date(2026, 4, 20 - Math.floor(i / 3)).toISOString().split('T')[0],
      pageCount: 14 + Math.floor(Math.random() * 12),
    })),
  },
  {
    id: 'tianguancifu',
    title: '天官赐福',
    author: '墨香铜臭',
    coverImage: 'https://readdy.ai/api/search-image?query=Ethereal%20Chinese%20fantasy%20manga%20cover%20with%20a%20graceful%20male%20figure%20in%20flowing%20white%20robes%20surrounded%20by%20silver%20butterflies%2C%20heavenly%20palace%20in%20misty%20background%2C%20delicate%20ink%20wash%20painting%20style%2C%20soft%20silver%20and%20crimson%20accents%2C%20dreamy%20atmosphere%2C%20clean%20simple%20background%2C%20vertical%20book%20cover%20style&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    description: '八百年前谢怜是风光无限的太子殿下，八百年后他第三次飞升，成了一个没有信众的破烂神。霉运缠身的他，遇到了那个神秘的红衣少年。',
    longDescription: '八百年前，谢怜是金枝玉叶的太子殿下，风光无限。八百年后，他第三次飞升成仙，却成了一个没有信众、没有香火的破烂神。为了偿还八百万功德，他不得不下凡处理各种诡异的委托。而在一次任务中，他遇到了那个神秘的红衣少年花城——一个与他有着说不清道不明渊源的人。',
    status: '已完结',
    categories: ['guoman', 'xuanhuan', 'lianai'],
    rating: 9.6,
    viewCount: 21200000,
    favoriteCount: 5900000,
    updateTime: '2026-04-10',
    tags: ['古风', '仙侠', '奇幻', '唯美', '经典'],
    chapters: Array.from({ length: 98 }, (_, i) => ({
      id: `tgcf-ch-${i + 1}`,
      title: `第${i + 1}话`,
      chapterNumber: i + 1,
      updateTime: new Date(2026, 3, 10 - Math.floor(i / 2)).toISOString().split('T')[0],
      pageCount: 20 + Math.floor(Math.random() * 10),
    })),
  },
  {
    id: 'modaozushi',
    title: '魔道祖师',
    author: '墨香铜臭',
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20Chinese%20cultivation%20manga%20cover%20with%20a%20mysterious%20man%20in%20black%20robes%20playing%20a%20flute%2C%20ghostly%20spirits%20surrounding%20him%2C%20ancient%20Chinese%20landscape%20with%20misty%20mountains%2C%20red%20and%20black%20color%20scheme%2C%20atmospheric%20lighting%2C%20clean%20simple%20background%2C%20vertical%20book%20cover%20style&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    description: '夷陵老祖魏无羡死后十三年，莫家庄一个疯子通过献舍禁术让他重生了。重活一世，他不仅要解开前世未了之谜，更与故人蓝忘机再次相遇。',
    longDescription: '夷陵老祖魏无羡，生前因修炼鬼道而遭人唾弃，最终被仙门百家围攻至死。十三年后，莫家庄一个疯子通过献舍禁术让他重生。重活一世，魏无羡发现自己卷入了一连串诡异的事件之中。与此同时，他与前世旧识蓝忘机再次相遇，两人携手揭开了一个埋藏十几年的惊天秘密。',
    status: '已完结',
    categories: ['guoman', 'xuanhuan', 'xuanyi'],
    rating: 9.7,
    viewCount: 19800000,
    favoriteCount: 5600000,
    updateTime: '2026-03-25',
    tags: ['古风', '仙侠', '悬疑', '重生', '经典'],
    chapters: Array.from({ length: 135 }, (_, i) => ({
      id: `mdzs-ch-${i + 1}`,
      title: `第${i + 1}话`,
      chapterNumber: i + 1,
      updateTime: new Date(2026, 2, 25 - Math.floor(i / 3)).toISOString().split('T')[0],
      pageCount: 17 + Math.floor(Math.random() * 11),
    })),
  },
  {
    id: 'yirenzhixia',
    title: '一人之下',
    author: '米二',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20urban%20fantasy%20manga%20cover%20with%20a%20young%20man%20using%20supernatural%20qi%20energy%20power%2C%20traditional%20taoist%20symbols%20floating%20around%2C%20modern%20city%20and%20ancient%20temple%20fusion%20background%2C%20dynamic%20martial%20arts%20pose%2C%20bold%20color%20contrast%2C%20clean%20simple%20background%2C%20vertical%20book%20cover%20style&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    description: '普通大学生张楚岚在爷爷的坟墓被盗后，遇到了一个神秘少女冯宝宝。从此，他被卷入了一个充满异人、道术和各种奇异能力的世界。',
    longDescription: '张楚岚本是一个普通的大学生，过着平静的校园生活。直到有一天，爷爷的坟墓被盗，一个自称冯宝宝的神秘少女闯入了他的生活。从此，他被卷入了"异人"的世界——一个隐藏在现代社会之下，由拥有各种奇异能力的异人组成的江湖。道术、炁功、机关术……一场波澜壮阔的冒险就此展开。',
    status: '连载中',
    categories: ['guoman', 'rexue', 'xuanyi'],
    rating: 9.5,
    viewCount: 14500000,
    favoriteCount: 3800000,
    updateTime: '2026-08-02',
    tags: ['异能', '热血', '悬疑', '道教', '现代'],
    chapters: Array.from({ length: 310 }, (_, i) => ({
      id: `yrzx-ch-${i + 1}`,
      title: `第${i + 1}话`,
      chapterNumber: i + 1,
      updateTime: new Date(2026, 7, 2 - Math.floor(i / 4)).toISOString().split('T')[0],
      pageCount: 16 + Math.floor(Math.random() * 10),
    })),
  },
  {
    id: 'huyaoxiaohongniang',
    title: '狐妖小红娘',
    author: '小新',
    coverImage: 'https://readdy.ai/api/search-image?query=Romantic%20Chinese%20fantasy%20manga%20cover%20with%20a%20beautiful%20fox%20spirit%20girl%20in%20traditional%20red%20hanfu%2C%20cherry%20blossom%20petals%20floating%2C%20ancient%20Chinese%20matchmaker%20theme%2C%20soft%20pink%20and%20red%20color%20tones%2C%20dreamy%20romantic%20atmosphere%2C%20clean%20simple%20background%2C%20vertical%20book%20cover%20style&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    description: '狐妖涂山苏苏为了成为真正的红线仙，与道士白月初一起，帮助前世恋人再续前缘。一个个感人至深的故事，诉说着跨越千年的爱恋。',
    longDescription: '在一个人与妖共存的世界里，狐妖涂山一族掌管着世间姻缘。小狐妖涂山苏苏梦想成为最厉害的红线仙，为前世恋人牵线搭桥。她与一气道盟的道士白月初组成搭档，帮助一对对前世恋人再续前缘。而在这过程中，苏苏自己也逐渐发现了一个关于自己身世的惊天秘密……',
    status: '连载中',
    categories: ['guoman', 'lianai', 'qihuan'],
    rating: 9.4,
    viewCount: 13200000,
    favoriteCount: 3400000,
    updateTime: '2026-08-01',
    tags: ['狐妖', '恋爱', '奇幻', '前世今生', '感人'],
    chapters: Array.from({ length: 280 }, (_, i) => ({
      id: `hyxhn-ch-${i + 1}`,
      title: `第${i + 1}话`,
      chapterNumber: i + 1,
      updateTime: new Date(2026, 7, 1 - Math.floor(i / 4)).toISOString().split('T')[0],
      pageCount: 15 + Math.floor(Math.random() * 12),
    })),
  },
  {
    id: 'zhenhunjie',
    title: '镇魂街',
    author: '许辰',
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20action%20Chinese%20manga%20cover%20with%20a%20fierce%20warrior%20summoning%20a%20giant%20guardian%20spirit%2C%20ancient%20Chinese%20street%20scene%20burning%20in%20background%2C%20intense%20battle%20atmosphere%2C%20fire%20and%20shadow%20effects%2C%20red%20and%20black%20color%20scheme%2C%20clean%20simple%20background%2C%20vertical%20book%20cover%20style&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    description: '普通的大学实习生夏铃在收到一封神秘面试通知后，误入了连接人界与灵域的镇魂街。在这里，每个寄灵人都拥有自己的守护灵，而她也被卷入了一场惊天阴谋。',
    longDescription: '夏铃是一个普通的大学实习生，却在收到一封神秘面试通知后，意外闯入了镇魂街——一个专门吸纳亡灵、连接人界与灵域的神秘之地。在这里，她遇到了镇魂将曹焱兵，并得知自己也是一名寄灵人。随着各种强大的亡灵和守护灵的出现，一场关乎两个世界命运的宏大战争即将拉开帷幕。',
    status: '连载中',
    categories: ['guoman', 'rexue', 'qihuan'],
    rating: 9.3,
    viewCount: 11600000,
    favoriteCount: 2900000,
    updateTime: '2026-07-30',
    tags: ['热血', '奇幻', '守护灵', '战斗', '动作'],
    chapters: Array.from({ length: 265 }, (_, i) => ({
      id: `zhj-ch-${i + 1}`,
      title: `第${i + 1}话`,
      chapterNumber: i + 1,
      updateTime: new Date(2026, 6, 30 - Math.floor(i / 4)).toISOString().split('T')[0],
      pageCount: 17 + Math.floor(Math.random() * 13),
    })),
  },
  {
    id: 'biaoren',
    title: '镖人',
    author: '许先哲',
    coverImage: 'https://readdy.ai/api/search-image?query=Gritty%20Chinese%20historical%20martial%20arts%20manga%20cover%20with%20a%20scarred%20swordsman%20in%20worn%20traveler%20clothes%2C%20desert%20landscape%20with%20sandstorms%2C%20ancient%20China%20escort%20agency%20theme%2C%20rough%20brushstroke%20ink%20style%2C%20sepia%20and%20dark%20brown%20tones%2C%20raw%20and%20powerful%20feeling%2C%20clean%20simple%20background%2C%20vertical%20book%20cover%20style&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    description: '大业三年，隋炀帝杨广暴虐无道。一个身手不凡的镖客刀马，行走于西域大漠之中，护送着一批又一批的商队，同时躲避着来自朝廷的追杀。',
    longDescription: '大业三年，隋王朝在隋炀帝杨广的暴虐统治下民不聊生。身手不凡的镖客刀马带着小七，行走于西域大漠，靠护送商队为生。在一次护镖途中，他接下了一趟改变命运的镖——护送一个神秘人物穿越整个西域。朝廷的追杀、江湖的恩怨、大漠的风沙……一部硬派武侠传奇，就此展开。',
    status: '连载中',
    categories: ['guoman', 'wuxia', 'rexue'],
    rating: 9.6,
    viewCount: 9800000,
    favoriteCount: 2500000,
    updateTime: '2026-07-28',
    tags: ['武侠', '历史', '硬派', '西域', '江湖'],
    chapters: Array.from({ length: 112 }, (_, i) => ({
      id: `br-ch-${i + 1}`,
      title: `第${i + 1}话`,
      chapterNumber: i + 1,
      updateTime: new Date(2026, 6, 28 - Math.floor(i / 2)).toISOString().split('T')[0],
      pageCount: 22 + Math.floor(Math.random() * 14),
    })),
  },
  {
    id: 'dalisi',
    title: '大理寺日志',
    author: 'RC',
    coverImage: 'https://readdy.ai/api/search-image?query=Humorous%20Chinese%20historical%20mystery%20manga%20cover%20featuring%20a%20white%20cat%20wearing%20ancient%20Chinese%20official%20robe%20and%20hat%2C%20ancient%20Chinese%20government%20office%20background%2C%20lighthearted%20comedy%20vibe%2C%20warm%20yellow%20and%20brown%20color%20palette%2C%20anthropomorphic%20cat%20character%2C%20clean%20simple%20background%2C%20vertical%20book%20cover%20style&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    description: '唐朝武周时期，陈拾来到洛阳寻找失踪的哥哥，却阴差阳错进入了大理寺当差。在这里他遇到了一个奇怪的"上司"——一只会说人话的大白猫李饼。',
    longDescription: '唐朝武周时期，乡下少年陈拾来到繁华的洛阳城寻找失踪的哥哥。阴差阳错之下，他进入了大理寺当差。令他惊讶的是，大理寺少卿竟然是一只会说人话的大白猫——李饼。在跟着这只猫上司处理各种离奇案件的过程中，陈拾逐渐揭开了一个笼罩洛阳城的大阴谋。',
    status: '连载中',
    categories: ['guoman', 'gaoxiao', 'xuanyi'],
    rating: 9.2,
    viewCount: 8700000,
    favoriteCount: 2100000,
    updateTime: '2026-07-25',
    tags: ['搞笑', '悬疑', '历史', '猫咪', '探案'],
    chapters: Array.from({ length: 180 }, (_, i) => ({
      id: `dls-ch-${i + 1}`,
      title: `第${i + 1}话`,
      chapterNumber: i + 1,
      updateTime: new Date(2026, 6, 25 - Math.floor(i / 3)).toISOString().split('T')[0],
      pageCount: 14 + Math.floor(Math.random() * 10),
    })),
  },
  {
    id: 'luoxiaohei',
    title: '罗小黑战记',
    author: 'MTJJ',
    coverImage: 'https://readdy.ai/api/search-image?query=Cute%20Chinese%20fantasy%20manga%20cover%20with%20an%20adorable%20black%20cat%20spirit%20with%20big%20green%20eyes%2C%20magical%20forest%20background%20with%20glowing%20fireflies%2C%20whimsical%20and%20heartwarming%20style%2C%20soft%20green%20and%20warm%20yellow%20color%20palette%2C%20gentle%20atmosphere%2C%20clean%20simple%20background%2C%20vertical%20book%20cover%20style&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    description: '猫妖罗小黑在森林家园被毁后，开始了流浪之旅。在人类世界中，他遇到了形形色色的人和妖，也逐渐理解了人类与妖精之间复杂的关系。',
    longDescription: '一只名叫罗小黑的黑色猫妖，在森林家园被人类砍伐后失去了栖身之所，开始了流浪之旅。在人类世界中，他遇到了善良的人类女孩罗小白，以及执行者无限等形形色色的人物。在与他们的相处中，小黑逐渐理解了人类与妖精之间复杂而微妙的关系，也找到了属于自己的归宿。',
    status: '连载中',
    categories: ['guoman', 'qihuan', 'gaoxiao'],
    rating: 9.5,
    viewCount: 10200000,
    favoriteCount: 2700000,
    updateTime: '2026-07-22',
    tags: ['治愈', '奇幻', '猫咪', '搞笑', '温馨'],
    chapters: Array.from({ length: 48 }, (_, i) => ({
      id: `lxh-ch-${i + 1}`,
      title: `第${i + 1}话`,
      chapterNumber: i + 1,
      updateTime: new Date(2026, 6, 22 - Math.floor(i)).toISOString().split('T')[0],
      pageCount: 8 + Math.floor(Math.random() * 6),
    })),
  },
];

export const siteInfo = {
  name: '吹雪漫画网',
  slogan: '精选好漫画，畅快免费读',
  description: '吹雪漫画网是一个致力于为用户提供高品质漫画免费阅读的平台。我们精选国内外优秀漫画作品，涵盖国产漫画、热血、恋爱、玄幻、武侠、科幻、悬疑、搞笑、奇幻、都市等多种类型，以高清画质和流畅的下拉式阅读体验，让每一位漫画爱好者都能享受阅读的乐趣。',
  email: 'contact@chuixue.manhua.com',
  qq: '1234567890',
  wechat: 'chuixuemanhua',
  founded: '2020年',
  comicCount: '50,000+',
  userCount: '8,000,000+',
  dailyActive: '500,000+',
};

export const testimonials = [
  {
    id: '1',
    name: '小明',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20boy%20avatar%20with%20warm%20smile%2C%20simple%20circle%20portrait%2C%20clean%20background%2C%20soft%20lighting&width=100&height=100&seq=avatar-01&orientation=squarish',
    content: '吹雪漫画网的画质真的太棒了！黑莲花攻略手册每一话都更新得很快，而且完全没有删减，追漫体验超好。这个漫画网站的阅读界面也特别流畅。',
    rating: 5,
  },
  {
    id: '2',
    name: '小猫咪',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20girl%20avatar%20with%20pink%20hair%2C%20simple%20circle%20portrait%2C%20clean%20background%2C%20soft%20lighting&width=100&height=100&seq=avatar-02&orientation=squarish',
    content: '终于找到一个能完整看黑莲花攻略手册的漫画网站了！吹雪漫画网的下拉式阅读设计太方便了，不用翻页，一口气能看好几十话。',
    rating: 5,
  },
  {
    id: '3',
    name: '二次元达人',
    avatar: 'https://readdy.ai/api/search-image?query=Cool%20anime%20style%20teen%20avatar%20with%20headphones%2C%20simple%20circle%20portrait%2C%20clean%20background%2C%20soft%20lighting&width=100&height=100&seq=avatar-03&orientation=squarish',
    content: '吹雪漫画网的漫画分类很齐全，国产漫画、热血、恋爱各种类型都有。而且每部漫画都是无删减版本，看得很过瘾。已经推荐给身边所有漫友了！',
    rating: 5,
  },
  {
    id: '4',
    name: '夜雨声烦',
    avatar: 'https://readdy.ai/api/search-image?query=Elegant%20anime%20style%20young%20woman%20avatar%20with%20long%20dark%20hair%2C%20simple%20circle%20portrait%2C%20clean%20background%2C%20soft%20lighting&width=100&height=100&seq=avatar-04&orientation=squarish',
    content: '作为黑莲花攻略手册的老粉，吹雪漫画网是我用过最好的漫画阅读平台。无删减内容保证剧情完整，下拉式设计非常符合手机阅读习惯。',
    rating: 5,
  },
];